import React from 'react';
import PropTypes from 'prop-types';
import s from './MedalTallyWrapper.scss';
import { IMAGE_URL } from '../../../../../constants';

const MedalTallyWrapper = props => {
  const { items = {} } = props.sectionItem || {};
  const { isWapView } = props;
  const groupDataList = items;

  const formatRank = rank => {
    if (rank === null) {
      return '-';
    } else if (rank < 10) {
      return `0${rank}`;
    }
    return rank;
  };

  return (
    <div className={s.TopBannerWrap}>
      <div className={`${s.TopBanner} base_shimmer`}>
        <img
          src={
            !isWapView
              ? 'https://static.toiimg.com/photo/112040948.jpg'
              : 'https://static.toiimg.com/photo/112040661.jpg'
          }
          alt=""
        />
        <div className={s.bannerText}>
          <h1 className={s.headText}>
            <span className={s.logoHead}>
              <img src={`${IMAGE_URL}111579755.cms`} alt="" />
              {groupDataList?.event_details?.event_name || 'Paris 2024'}
            </span>
            <span className={s.heading}>Medal Tally</span>
          </h1>
          <div className={s.logo}>
            <div className={s.logoHead}>
              <img src={`${IMAGE_URL}111580093.cms`} alt="" />
            </div>
          </div>
        </div>
      </div>

      <div className={`${s.points_wrap} medal_tally_table`}>
        <ul className={s.list}>
          <li className={s.head}>
            <span className={s.rank}>{!isWapView ? 'Rank' : '#'}</span>
            <span className={s.country}>Country</span>
            <span className={s.gold}>
              <i />
              {!isWapView ? 'Gold' : 'G'}
            </span>
            <span className={s.silver}>
              <i /> {!isWapView ? 'Silver' : 'S'}
            </span>
            <span className={s.bronze}>
              <i /> {!isWapView ? 'Bronze' : 'B'}
            </span>
            <span className={s.total}>{!isWapView ? 'Total' : 'T'}</span>
          </li>

          {groupDataList &&
            groupDataList?.medals_tally &&
            Array.isArray(groupDataList?.medals_tally) &&
            groupDataList?.medals_tally.length > 0 && (
              <>
                {groupDataList?.medals_tally
                  .sort((a, b) => {
                    if (a.team_name === 'India') {
                      return -1;
                    } else if (b.team_name === 'India') {
                      return 1;
                    }
                    return 0;
                  })
                  .map(event => (
                    <li
                      key={event.rank}
                      className={
                        event.team_name === 'India' ? `${s.selected}` : ''
                      }
                    >
                      <span className={s.rank}>
                        <i>{formatRank(event.rank)}</i>
                      </span>
                      <span className={s.country}>
                        <i
                          className={`${s.flagName} ${
                            s[event.short_team_name]
                          }`}
                        />{' '}
                        <span>{event.team_name}</span>
                      </span>
                      <span className={s.gold}>{event.gold_count}</span>
                      <span className={s.silver}>{event.silver_count}</span>
                      <span className={s.bronze}>{event.bronze_count}</span>
                      <span className={s.total}>{event.medals_count}</span>
                    </li>
                  ))}
              </>
            )}
        </ul>
      </div>
    </div>
  );
};

MedalTallyWrapper.propTypes = {
  sectionItem: PropTypes.objectOf({}),
  isWapView: PropTypes.bool,
};
MedalTallyWrapper.defaultProps = {
  sectionItem: {},
  isWapView: false,
};

export default React.memo(MedalTallyWrapper);
